export default {
  label: 'Posts by id',
};
